import radioGroupUrl from './radioGroupComponent.html';

class RadioGroupCtrl {
  $onInit() {
    this._validateBindings();
  }

  _validateBindings() {
    if (!this.options) {
      throw new Error('Options for radio buttons group are not defined');
    }

    if (!this.options.every((option) => 'value' in option && 'label' in option)) {
      throw new Error('Every radio button option has to have a value and a label');
    }
  }
}

export default {
  templateUrl: radioGroupUrl,
  controller: RadioGroupCtrl,
  controllerAs: 'ctrl',
  bindings: {
    model: '=',
    options: '<',
  },
};
